import axios from "axios";
import { triggerGlobalError } from "./errorEvent";

const handleError = (error) => {
  const status = error?.response?.status;
  if (status === 401) {
    window.location.href = "/login";
    return;
  }
  triggerGlobalError(status || "500");
  console.error(error, status);
};

export async function axiosGet(url, token, params = {}) {
  try {
    let response = await axios.get(url, {
      headers: {
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function axiosPost(url, data, token, params = {}) {
  try {
    let response = await axios.post(url, data, {
      headers: {
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}
export async function axiosPatch(url, data, token) {
  try {
    let response = await axios.patch(url, data, {
      headers: {
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function axiosPut(url, data, token, params = {}) {
  try {
    let response = await axios.put(url, data, {
      headers: {
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function axiosDelete(url, token, params = {}) {
  try {
    let response = await axios.delete(url, {
      headers: {
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function axiosPostWithFile(url, data, token, params = {}) {
  try {
    let response = await axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}
export async function axiosPutWithFile(url, data, token, params = {}) {
  try {
    let response = await axios.put(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function axiosGetWithFile(url, data, token, params = {}) {
  try {
    let response = await axios.get(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
      params: params,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export async function getNoAuth(url, params = {}) {
  try {
    let response = await axios.get(url, {
      params: params,
    });
    return response;
  } catch (error) {
    handleError(error);
  }
}
